export enum MatchResultType {
  MATCH = 1,
  NOMATCH = 2,
  PARTIALMATCH = 3,
}
